import { createSelector } from 'reselect';
// helpers/constants
//////////////////////////////////////////////////

const selectGlobalStore = (state) => state.global;

const makeSelectGoogleApiKey = () => createSelector(
  selectGlobalStore,
  (global) => global.googleApiKey,
);

const makeSelectInitialSplashScreen = () => createSelector(
  selectGlobalStore,
  (global) => global.initialSplashScreenSetting,
);

const makeSelectGlobal = () => createSelector(
  selectGlobalStore,
  (global) => ({ ...global }),
);

const makeSelectSubmitLoading = () => createSelector(
  selectGlobalStore,
  ({ submitLoading }) => submitLoading,
);

const makeSelectInitialConfigsLoaded = () => createSelector(
  selectGlobalStore,
  (global) => global.initialConfigsLoaded,
);

const makeSelectInitialDataLoaded = () => createSelector(
  selectGlobalStore,
  (global) => global.initialDataLoaded,
);

const makeSelectInitialDataLoading = () => createSelector(
  selectGlobalStore,
  (global) => global.initialDataLoading,
);

const makeSelectDocumentTemplates = () => createSelector(
  selectGlobalStore,
  ({ documentTemplates }) => documentTemplates,
);

const makeSelectConnectedToMailIntegrationEmails = () => createSelector(
  selectGlobalStore,
  ({ connectedToMailIntegrationEmails }) => connectedToMailIntegrationEmails,
);

const makeSelectConnectionToMailIntegrationRequired = () => createSelector(
  selectGlobalStore,
  ({ connectionToMailIntegrationRequired }) => connectionToMailIntegrationRequired,
);

const makeSelectMailIntegrationType = () => createSelector(
  selectGlobalStore,
  ({ mailServiceIntegrationType }) => mailServiceIntegrationType,
);

const makeSelectShowDriverOnboardingTab = () => createSelector(
  selectGlobalStore,
  ({ showDriverOnboardingTab }) => showDriverOnboardingTab,
);

const makeSelectSocketConnected = () => createSelector(
  selectGlobalStore,
  ({ socketConnected }) => socketConnected,
);

const makeSelectExistByScopeAndNames = () => createSelector(
  selectGlobalStore,
  ({ existByScopeAndNames }) => existByScopeAndNames,
);

export {
  makeSelectGlobal,
  selectGlobalStore,
  makeSelectGoogleApiKey,
  makeSelectSubmitLoading,
  makeSelectSocketConnected,
  makeSelectDocumentTemplates,
  makeSelectInitialDataLoaded,
  makeSelectInitialDataLoading,
  makeSelectInitialSplashScreen,
  makeSelectMailIntegrationType,
  makeSelectInitialConfigsLoaded,
  makeSelectExistByScopeAndNames,
  makeSelectShowDriverOnboardingTab,
  makeSelectConnectedToMailIntegrationEmails,
  makeSelectConnectionToMailIntegrationRequired,
};
